module.exports = __webpack_public_path__ + "img/uploaded-view.c4d7be5b.svg";